import { Add, Delete, Upload } from "@mui/icons-material";
import React, { useState } from "react";
import SelectDate from "../../../components/ui/select-date";
import { Input } from "../../../components/ui";
import NodataAvailable from "../../../assets/images/NodataAvailable.svg";
import moment from "moment";

const MarketHolidays: React.FC<{
  handleChangeHoliday: any;
  handleDeleteHoliday: any;
  holidays: any;
}> = ({ handleChangeHoliday, handleDeleteHoliday, holidays }) => {
  return (
    <div className="">
      {holidays.length === 0 ? (
        <div className="flex items-center justify-center h-full">
          <img src={NodataAvailable} alt="No data available" />
        </div>
      ) : (
        <div className="space-y-3">
          {holidays
            ?.filter((h: any) => h.status !== 0)
            .map((h: any, i: number) => (
              <div key={i} className="flex gap-4 items-end">
                <div className="flex flex-1 flex-col ">
                  <span className="text-sm"> Date</span>
                  <SelectDate
                    onChange={(date) => handleChangeHoliday(i, "date", date)}
                    selectedDate={h.date}
                    styles={{ padding: "9px" }}
                    maxDate={moment().add(1, "years").format("YYYY-MM-DD")}
                  />
                  {/* <label className="text-sm font-medium mb-1 text-gray-600">
                  Date
                </label>
                <input
                  type="date"
                  value={h.date}
                  onChange={(e) =>
                    handleChangeHoliday(i, "date", e.target.value)
                  }
                  className="border rounded px-3 py-2 w-full"
                /> */}
                </div>

                <div className="flex flex-col ">
                  <Input
                    label=" Event Name "
                    type="text"
                    required={true}
                    className="flex-1"
                    value={h.event}
                    onChange={(e) =>
                      handleChangeHoliday(i, "event", e.target.value)
                    }
                  />
                </div>

                <div
                  onClick={() => handleDeleteHoliday(i)}
                  className="mt-2  bg-red-100 hover:bg-red-200 cursor-pointer rounded-full color-red flex items-center justify-center w-[30px] h-[30px]"
                >
                  <Delete style={{ fontSize: 16 }} />
                </div>
              </div>
            ))}
        </div>
      )}
    </div>
  );
};

export default MarketHolidays;
